export default "__VITE_ASSET__DOhDisKx__"